import Framework from './lib/framework/framework';

Framework.initialize();
